import { Component, EventEmitter, Input, Output, inject } from "@angular/core";

import { PermissionsService } from "../../../shared/services";
import { Shift, Task } from "../../../shared/types";
import { TasksModel } from "../../tasks.model";
import { TaskRecordType } from "app/shared/enums";

@Component({
	selector: "ic-task-swipe-list",
	templateUrl: "./task-swipe-list.component.html",
	styleUrls: ["./task-swipe-list.component.scss"],
	standalone: false,
})
export class TaskSwipeListComponent {
	private readonly tasksModel = inject(TasksModel);
	private readonly permissionsService = inject(PermissionsService);

	// @ts-expect-error TS2564
	@Input() tasks: { completed: Task[]; uncompleted: Task[] };
	// @ts-expect-error TS2564
	@Input() shift: Shift;

	@Output() selectTask = new EventEmitter<Task>();

	onTaskSwipe(task: Task) {
		if (!task.hasUserHandlePermission || !this.canUpdateTask(task)) {
			this.selectTask.emit(task);

			return;
		}

		if (!task.form) {
			this.updateUndoableTask(task);

			return;
		}

		this.selectTask.emit(task);
	}

	canUpdateTask(task: Task) {
		if (task.recordType === TaskRecordType.WOUNDCARE) {
			return this.permissionsService.userHasPermissions(["MEDAPP.CARE.ADMINISTER_WOUNDCARE"]);
		} else {
			return this.permissionsService.userHasPermissions(["MEDAPP.CARE.ADMINISTER_CARE"]);
		}
	}

	updateUndoableTask(task: Task) {
		this.tasksModel.updateTask(task.patientId, task.id, { executed: true, important: false }, task).subscribe();
	}
}
